export function isPrescriber(user) {
  if (!user) return false;
  return user.can_prescribe === true;
}
